export const UkAwards = [
  {
    alt: 'diy week awards',
    src: 'awards/uk/diy-week-awards.jpg',
  },
  {
    alt: 'retail week award',
    src: 'awards/uk/retail-week-awards.png',
  },
];

export const ITAwards = [
  {
    alt: 'Netcomm business partner Menzione hobby giardinaggio e fai da te',
    src: 'netcomm-hobby.png',
    dataQa: 'guaranteesNetcommHobbyElm',
  },
  {
    alt: 'Netcomm business partner Winner start-up e nuove promesse',
    src: 'netcomm-startup.png',
    dataQa: 'guaranteesNetcommStartupElm',
  },
];
